<template>
	<div>
		<common-header navbar-index=2></common-header>
		<robot-banner></robot-banner>
		<index-content></index-content>
		<common-footer></common-footer>
	</div>
</template>

<script>
	import CommonHeader from '@/pages/common/Header'
	import RobotBanner from '@/pages/robot/components/RobotBanner'
	import IndexContent from '@/pages/robot/components/IndexContent'
	import CommonFooter from '@/pages/common/Footer'
	import axios from 'axios'
	export default {
		name: 'Robot',
		components: {
			CommonHeader,
			RobotBanner,
			IndexContent,
			CommonFooter
		},
		data() {
			return {
				descContentList: []
			}
		},
		methods: {
			/*getDataInfo() {
				axios.get('/itmswcn/learn/robot/news/queryAll')
					.then(this.getDataInfoSucc)
			},
			getDataInfoSucc(res) {
				res = res.data
				if(res.code == 100 && res.data) {
					this.descContentList = res.data
				}
			}*/
		},
		mounted() {
			//			this.getDataInfo()
		}
	};
</script>

<style lang="scss" scoped>

</style>